<template>
  <el-dialog
    class="orderStatusDialog"
    :title="orderNo"
    width="40%"
    :append-to-body="true"
    :visible.sync="boxDialogVisible"
  >
    <el-table
      :data="boxData"
      stripe
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column
        property="box_code"
        label="箱码"
        width="220"
      ></el-table-column>
      <el-table-column
        property="status"
        label="到达状态"
      ></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  props: ['boxData'],
  data () {
    return {
      orderNo: '',
      boxDialogVisible: false
    }
  },
  methods: {}
}
</script>
<style lang="scss">
// .orderStatusDialog {
//   .el-table .cell, .el-table th div {
//     // padding: 8px;
//   }
// }
// .el-dialog__header {
//   background-color: rgb(33, 42, 51);
//   height: 40px;
//   line-height: 40px;
//   padding: 0 0 0 10px;
//   .el-dialog__title,
//   .el-dialog__headerbtn .el-dialog__close {
//     font-size: 16px;
//     color: #fff;
//   }
//   .el-dialog__headerbtn {
//     top: 11px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/order/order-status-dialog.vue